import type { Span, TimeScale } from '../types';

export type BarLayout = {
  /** Pixel-domain left offset from `windowStartDay`. Prefer this only when comparing directly
   * against another pixel value, e.g. `scrollLeft` for an off-screen check. It goes stale on a
   * zoom change — `pxPerDay` is baked in — so anything else should prefer `startOffsetDays`. */
  x: number;
  /** Pixel-domain width. Same zoom-change caveat as `x`; prefer `spanDays` for anything else. */
  width: number;
  /** Day-domain left offset from `windowStartDay`. Survives a zoom change unchanged — CSS
   * multiplies it by `--gantt-px-per-day`, so a zoom change is one variable write rather than a
   * recompute of every bar. Can be negative when the span starts before the window origin. */
  startOffsetDays: number;
  /** Day-domain width: the span's inclusive length in days. Day-domain counterpart of `width`. */
  spanDays: number;
};

export const barLayout = (span: Span, scale: TimeScale, windowStartDay: number): BarLayout => {
  const spanDays = span.endDay - span.startDay + 1;

  return {
    x: scale.xOf(span.startDay, windowStartDay),
    width: spanDays * scale.pxPerDay,
    startOffsetDays: span.startDay - windowStartDay,
    spanDays,
  };
};
